if (!customElements.get('promotional-progress')) {
  class PromotionalProgress extends HTMLElement {
    constructor() {
      super();
      this.itemLabel = this.getAttribute('item-label') || 'item';
      this.isCompact = this.hasAttribute('compact');
      this.abortController = new AbortController();
    }

    connectedCallback() {
      this.init();
      // Dawn theme cart update subscription
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.fetchCartAndRender();
        });
      }
      
      // Fallback or additional event listeners for other themes
      document.addEventListener('cart:updated', () => this.fetchCartAndRender(), { signal: this.abortController.signal });
      document.addEventListener('cart:change', () => this.fetchCartAndRender(), { signal: this.abortController.signal });
      document.addEventListener('cart:refresh', () => this.fetchCartAndRender(), { signal: this.abortController.signal });
      
      // Global Fetch Interceptor to catch any cart API calls and update widget
      const originalFetch = window.fetch;
      window.fetch = async (...args) => {
        const response = await originalFetch(...args);
        if (args[0] && typeof args[0] === 'string' && (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update'))) {
          // Allow the cart operation to finish, then fetch and render
          setTimeout(() => this.fetchCartAndRender(), 500);
        }
        return response;
      };
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      this.abortController.abort();
    }

    async init() {
      // First, see if we have liquid-rendered initial quantities (can be passed as data attrs)
      if (this.hasAttribute('data-initial-qty')) {
        const qty = parseInt(this.getAttribute('data-initial-qty'), 10);
        this.renderState(window.PromotionEngine.getPromotionState({ items: [{ product_type: this.itemLabel, quantity: qty }] }));
      }
      
      await this.fetchCartAndRender();
    }

    async fetchCartAndRender() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) throw new Error('Failed to fetch cart');
        const cartData = await response.json();
        const state = window.PromotionEngine.getPromotionState(cartData);
        this.renderState(state);
      } catch (error) {
        console.error('Error updating promotional progress:', error);
      }
    }

    renderState(state) {
      const messages = window.PromotionEngine.getMessage(state, this.itemLabel);
      
      // Render HTML structure
      this.innerHTML = `
        <div class="promotional-progress ${state.isMax ? 'is-max' : ''} ${this.isCompact ? 'is-compact' : ''}">
          <div class="promotional-progress__header">
            <span class="promotional-progress__sparkle">✦</span>
            <h4 class="promotional-progress__title">${messages.title}</h4>
          </div>
          
          <div class="promotional-progress__body">
            <p class="promotional-progress__subtitle">${messages.subtitle}</p>
            
            <div class="promotional-progress__bar-container">
              <div class="promotional-progress__segments">
                ${Array.from({ length: state.maxQuantity }).map((_, i) => `
                  <div class="promotional-progress__segment ${i < state.eligibleQuantity ? 'is-filled' : ''}">&nbsp;</div>
                `).join('')}
              </div>
              <span class="promotional-progress__count">${state.eligibleQuantity} / ${state.maxQuantity}</span>
            </div>
          </div>
          
          <div class="promotional-progress__footer">
            <p>Discount applied automatically at checkout.</p>
          </div>
        </div>
      `;
    }
  }

  customElements.define('promotional-progress', PromotionalProgress);
}
